import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/plus-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-697e5a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "px-2",
  style: {"margin-top":"100px","margin-left":"-15px","padding-left":"0"}
}
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "client-details-welcome-title-consultant px-0" }
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-white rounded-xl p-3 flex justify-start drop-shadow-md mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Results")
  ])
], -1))
const _hoisted_7 = { class: "p-0" }
const _hoisted_8 = {
  "aria-expanded": "false",
  id: "featuredBox",
  class: "grid grid-cols-12 w-full ml-0.5 gap-10"
}
const _hoisted_9 = { class: "row-1 flex flex-col w-1/2 gap-4" }
const _hoisted_10 = {
  key: 0,
  id: "item-n-1",
  class: "boxItem col-span-12 w-full grid grid-cols-10 gap-2 bg-white rounded-xl drop-shadow-md p-3"
}
const _hoisted_11 = { class: "itemHead col-span-12 bg-[#f3f4f8] px-3 rounded-xl flex items-center justify-between min-h-14" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Questionnaire Criteria and Scores", -1))
const _hoisted_14 = { class: "data-view col-span-12 grid grid-cols-12 gap-2 collapsed-segment" }
const _hoisted_15 = { class: "flex col-span-6 bg-[#fbfaff] rounded-xl items-center justify-between gap-2 py-2 px-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start w-full" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Network Characteristics")
], -1))
const _hoisted_17 = { class: "flex col-span-6 bg-[#fbfaff] rounded-xl items-center justify-between gap-2 py-2 px-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start w-full" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Organisational Governance")
], -1))
const _hoisted_19 = { class: "flex col-span-6 bg-[#fbfaff] rounded-xl items-center justify-between gap-2 py-2 px-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start w-full" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Organisational Architecture")
], -1))
const _hoisted_21 = { class: "flex col-span-6 bg-[#fbfaff] rounded-xl items-center justify-between gap-2 py-2 px-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start w-full" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Technical IT Infrastructure")
], -1))
const _hoisted_23 = { class: "flex col-span-6 bg-[#fbfaff] rounded-xl items-center justify-between gap-2 py-2 px-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start w-full" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Human IT Infrastructure")
], -1))
const _hoisted_25 = { class: "flex col-span-6 bg-[#fbfaff] rounded-xl items-center justify-between gap-2 py-2 px-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start w-full" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Organisational Culture")
], -1))
const _hoisted_27 = { class: "flex col-span-6 bg-[#fbfaff] rounded-xl items-center justify-between gap-2 py-2 px-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start w-full" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Human Knowledge & Skills")
], -1))
const _hoisted_29 = {
  key: 1,
  id: "item-n-2",
  class: "boxItem col-span-12 w-full grid grid-cols-10 gap-2 bg-white rounded-xl drop-shadow-md p-3"
}
const _hoisted_30 = { class: "itemHead col-span-12 bg-[#f3f4f8] px-3 rounded-xl flex items-center justify-between min-h-14" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Environmental Pressure", -1))
const _hoisted_33 = { class: "data-view col-span-12 grid grid-cols-12 gap-2 collapsed-segment" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"flex col-span-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-center\" data-v-697e5a0c>Environment Factors</h4></div></div><div class=\"flex col-span-3 bg-[#fbfaff] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-center\" data-v-697e5a0c>Hostility</h4></div></div><div class=\"flex col-span-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-center\" data-v-697e5a0c>Dynamism</h4></div></div><div class=\"flex col-span-3 bg-[#fbfaff] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-center\" data-v-697e5a0c>Complexity</h4></div></div><div class=\"flex col-span-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>Mean</h4></div></div>", 5)
const _hoisted_39 = { class: "flex col-span-3 bg-[#fbfaff] rounded-xl p-2 items-center justify-between" }
const _hoisted_40 = { class: "flex justify-center w-full" }
const _hoisted_41 = { class: "flex col-span-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between" }
const _hoisted_42 = { class: "flex justify-center w-full" }
const _hoisted_43 = { class: "flex col-span-3 bg-[#fbfaff] rounded-xl p-2 items-center justify-between" }
const _hoisted_44 = { class: "flex justify-center w-full" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col-span-3 border-2 border-[#aedddb] rounded-xl p-2 items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Environmental Pressure")
  ])
], -1))
const _hoisted_46 = { class: "flex col-span-9 border-2 border-[#aedddb] rounded-xl p-2 items-center justify-between" }
const _hoisted_47 = { class: "flex justify-center w-full" }
const _hoisted_48 = { class: "row-2 flex flex-col w-1/2 gap-4" }
const _hoisted_49 = {
  key: 0,
  "aria-details": "data",
  id: "item-n-3",
  class: "boxItem col-span-12 w-full grid grid-cols-10 gap-2 bg-white rounded-xl drop-shadow-md p-3"
}
const _hoisted_50 = { class: "itemHead col-span-12 bg-[#f3f4f8] px-3 py-1.5 rounded-xl flex items-center justify-between min-h-14" }
const _hoisted_51 = { class: "flex items-center gap-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Innovation Capability Index 1", -1))
const _hoisted_53 = { class: "flex gap-4 items-center" }
const _hoisted_54 = { class: "viewBox flex bg-white px-3 py-2 rounded-xl gap-4 relative" }
const _hoisted_55 = {
  key: 0,
  class: "data-view col-span-12 grid grid-cols-12 gap-2 collapsed-segment"
}
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<div class=\"grid col-span-12 grid-cols-10 gap-2 collapsed-segment pb-0\" data-v-697e5a0c><div class=\"flex col-span-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between left-col-mw\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>Enabler #</h4></div></div><div class=\"flex col-span-1 bg-[#fbfaff] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>1</h4></div></div><div class=\"flex col-span-1 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>2</h4></div></div><div class=\"flex col-span-1 bg-[#fbfaff] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>3</h4></div></div><div class=\"flex col-span-1 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>4</h4></div></div><div class=\"flex col-span-1 bg-[#fbfaff] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>5</h4></div></div><div class=\"flex col-span-1 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>6</h4></div></div><div class=\"flex col-span-1 bg-[#fbfaff] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>7</h4></div></div></div>", 1)
const _hoisted_57 = { class: "grid col-span-12 grid-cols-10 gap-2 collapsed-segment pb-0" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col-span-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between left-col-mw" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Mean")
  ])
], -1))
const _hoisted_59 = { class: "flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between" }
const _hoisted_60 = { class: "flex justify-center w-full" }
const _hoisted_61 = { class: "flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between" }
const _hoisted_62 = { class: "flex justify-center w-full" }
const _hoisted_63 = { class: "flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between" }
const _hoisted_64 = { class: "flex justify-center w-full" }
const _hoisted_65 = { class: "flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between" }
const _hoisted_66 = { class: "flex justify-center w-full" }
const _hoisted_67 = { class: "flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between" }
const _hoisted_68 = { class: "flex justify-center w-full" }
const _hoisted_69 = { class: "flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between" }
const _hoisted_70 = { class: "flex justify-center w-full" }
const _hoisted_71 = { class: "flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between" }
const _hoisted_72 = { class: "flex justify-center w-full" }
const _hoisted_73 = { class: "flex col-span-12 gap-2" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "colspan-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between left-col-w" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-start mb-0 pb-0" }, "Mean Alignment")
  ])
], -1))
const _hoisted_75 = { class: "flex justify-center my-auto w-full" }
const _hoisted_76 = { class: "flex my-auto p-2 rounded-xl leading-4 w-full justify-center" }
const _hoisted_77 = { class: "grid col-span-12 grid-cols-10 gap-2 collapsed-segment pb-0" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col-span-3 border-2 border-[#aedddb] rounded-xl p-1 items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "ICI 1")
  ])
], -1))
const _hoisted_79 = { class: "flex col-span-3 border-2 border-[#aedddb] rounded-xl p-1 items-center justify-between" }
const _hoisted_80 = { class: "flex justify-center w-full" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col-span-4 border-2 border-[#aedddb] rounded-xl p-1 items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex p-2 rateBg2 bg-[#2d7e3c] text-white rounded-xl leading-4 font-semibold text-center" }, " 95.61 % MATCH - ")
  ])
], -1))
const _hoisted_82 = {
  key: 1,
  class: "graph-view col-span-12 grid grid-cols-10 collapsed-segment"
}
const _hoisted_83 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-start justify-center col-span-5 pl-12 pr-24 gap-4\" data-v-697e5a0c><div class=\"flex items-center gap-4\" data-v-697e5a0c><div class=\"\" data-v-697e5a0c><div class=\"shrink-0 grow-0 flex h-5 w-5 rounded-full border-2 border-black\" data-v-697e5a0c><p class=\"invisible\" data-v-697e5a0c>helolo</p></div></div><p class=\"uppercase text-lg leading-5\" data-v-697e5a0c>Position of enabler if aligned</p></div></div>", 1)
const _hoisted_84 = {
  key: 1,
  "aria-details": "data",
  id: "item-n-4",
  class: "boxItem col-span-12 w-full grid grid-cols-10 gap-2 bg-white rounded-xl drop-shadow-md p-3"
}
const _hoisted_85 = { class: "itemHead col-span-12 bg-[#f3f4f8] px-3 py-1.5 rounded-xl flex items-center justify-between min-h-14" }
const _hoisted_86 = { class: "flex items-center gap-2" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Innovation Capability Index 2", -1))
const _hoisted_88 = { class: "flex gap-4 items-center" }
const _hoisted_89 = { class: "viewBox flex bg-white px-3 py-2 rounded-xl gap-4 relative" }
const _hoisted_90 = {
  key: 0,
  class: "data-view col-span-12 grid grid-cols-12 gap-2 collapsed-segment"
}
const _hoisted_91 = /*#__PURE__*/_createStaticVNode("<div class=\"flex col-span-12 gap-2\" data-v-697e5a0c><div class=\"flex-1 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between left-col-w\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>Capabilities</h4></div></div><div class=\"flex-1 bg-[#fbfaff] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>Sensing</h4></div></div><div class=\"flex-1 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>Responding</h4></div></div><div class=\"flex-1 bg-[#fbfaff] rounded-xl p-2 justify-between\" data-v-697e5a0c><div class=\"flex justify-center w-full\" data-v-697e5a0c><h4 class=\"text-start\" data-v-697e5a0c>Learning</h4></div></div></div>", 1)
const _hoisted_92 = { class: "flex col-span-12 gap-2" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between left-col-w" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Mean")
  ])
], -1))
const _hoisted_94 = { class: "flex-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between align-content-center" }
const _hoisted_95 = { class: "flex justify-center w-full" }
const _hoisted_96 = { class: "flex-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between align-content-center" }
const _hoisted_97 = { class: "flex justify-center w-full" }
const _hoisted_98 = { class: "flex-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between align-content-center" }
const _hoisted_99 = { class: "flex justify-center w-full" }
const _hoisted_100 = { class: "flex col-span-12 gap-2" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "colspan-3 bg-[#f3f4f8] rounded-xl p-2 items-center justify-between left-col-w" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "Mean Alignment")
  ])
], -1))
const _hoisted_102 = { class: "flex justify-center w-full" }
const _hoisted_103 = { class: "flex p-2 rounded-xl leading-4 w-full justify-center" }
const _hoisted_104 = { class: "grid col-span-12 grid-cols-10 gap-2 collapsed-segment pb-0" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col-span-3 border-2 border-[#aedddb] rounded-xl p-1 items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "ICI 2")
  ])
], -1))
const _hoisted_106 = { class: "flex col-span-3 border-2 border-[#aedddb] rounded-xl p-1 items-center justify-between" }
const _hoisted_107 = { class: "flex justify-center w-full" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col-span-4 border-2 border-[#aedddb] rounded-xl p-1 items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex p-2 rateBg2 bg-[#2d7e3c] text-white rounded-xl leading-4 font-semibold text-center" }, " 95.61 % MATCH - ")
  ])
], -1))
const _hoisted_109 = {
  key: 1,
  class: "graph-view col-span-12 grid grid-cols-10 collapsed-segment"
}
const _hoisted_110 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-start justify-center col-span-5 pl-12 pr-24 gap-4\" data-v-697e5a0c><div class=\"flex items-center gap-4\" data-v-697e5a0c><div class=\"\" data-v-697e5a0c><div class=\"shrink-0 grow-0 flex h-5 w-5 rounded-full border-2 border-black\" data-v-697e5a0c><p class=\"invisible\" data-v-697e5a0c>helolo</p></div></div><p class=\"uppercase text-lg leading-5\" data-v-697e5a0c>Position of capability if aligned</p></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_to_project_button = _resolveComponent("back-to-project-button")!
  const _component_IciButton = _resolveComponent("IciButton")!
  const _component_download_report = _resolveComponent("download-report")!
  const _component_benchmark_details_panel = _resolveComponent("benchmark-details-panel")!
  const _component_Panel1 = _resolveComponent("Panel1")!
  const _component_Panel2 = _resolveComponent("Panel2")!
  const _component_Panel3 = _resolveComponent("Panel3")!
  const _component_Panel4 = _resolveComponent("Panel4")!
  const _component_AgilityRatingTooltip = _resolveComponent("AgilityRatingTooltip")!
  const _component_AgilityRatingPill = _resolveComponent("AgilityRatingPill")!
  const _component_GraphIci = _resolveComponent("GraphIci")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content px-5 flex flex-col gap-4 results-dashboard-content", { 'benchmark-mode': _ctx.showBenchmarkDetails }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.selectedClient?.name), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_back_to_project_button, {
            id: "backToAllClients",
            content: _ctx.constructLabel(_ctx.buttonBackToProject, _ctx.$t('companyForm.buttonBackToProject')),
            onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToProject())),
            btnStyle: "width: 260px;"
          }, null, 8, ["content"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_IciButton, {
              class: "benchmark-button",
              id: "benchmarkExplained",
              content: "\n            <div class='flex items-center gap-2'>\n              <i class='pi pi-question-circle'/></i>\n              <span>Understanding the results</span>\n            </div>\n            ",
              onButtonClick: _ctx.toggleBenchmarkDetails,
              btnStyle: "width: 260px;",
              dark: false
            }, null, 8, ["onButtonClick"]),
            _createVNode(_component_download_report, {
              id: "backToAllClients",
              btnStyle: "width: 180px;",
              dark: true
            })
          ])
        ])
      ]),
      _hoisted_6
    ]),
    _createVNode(_component_benchmark_details_panel, {
      isVisible: _ctx.showBenchmarkDetails,
      onClose: _ctx.toggleBenchmarkDetails
    }, null, 8, ["isVisible", "onClose"]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Panel1, {
          questionnaireResults: _ctx.questionnaireResults,
          visible: _ctx.itemN1,
          calculateColor: _ctx.calculateColor,
          getBgClass: _ctx.getBgClass,
          closeAction: () => {
            _ctx.itemn1(false); _ctx.resetView();
          }
        }, null, 8, ["questionnaireResults", "visible", "calculateColor", "getBgClass", "closeAction"]),
        _createVNode(_component_Panel2, {
          questionnaireResults: _ctx.questionnaireResults,
          visible: _ctx.itemN2,
          calculateBorder: _ctx.calculateBorder,
          getBgClass: _ctx.getBgClass,
          closeAction: () => {
            _ctx.itemn2(false); _ctx.resetView();
          }
        }, null, 8, ["questionnaireResults", "visible", "calculateBorder", "getBgClass", "closeAction"]),
        _createVNode(_component_Panel3, {
          questionnaireResults: _ctx.questionnaireResults,
          visible: _ctx.itemN3,
          calculateBorder: _ctx.calculateBorder,
          calculateColor: _ctx.calculateColor,
          getBgClass: _ctx.getBgClass,
          graphToggle: _ctx.graphToggle3,
          graphViewClick: _ctx.ici1GraphViewClick,
          closeAction: () => {
            _ctx.itemn3(false); _ctx.resetView();
          }
        }, null, 8, ["questionnaireResults", "visible", "calculateBorder", "calculateColor", "getBgClass", "graphToggle", "graphViewClick", "closeAction"]),
        _createVNode(_component_Panel4, {
          questionnaireResults: _ctx.questionnaireResults,
          visible: _ctx.itemN4,
          calculateBorder: _ctx.calculateBorder,
          calculateColor: _ctx.calculateColor,
          getBgClass: _ctx.getBgClass,
          graphToggle: _ctx.graphToggle4,
          graphViewClick: _ctx.ici2GraphViewClick,
          closeAction: () => {
            _ctx.itemn4(false); _ctx.resetView();
          }
        }, null, 8, ["questionnaireResults", "visible", "calculateBorder", "calculateColor", "getBgClass", "graphToggle", "graphViewClick", "closeAction"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['rowWrap ', 'flex', 'gap-4', 'w-full mt-4 ml-0.5', { row1: _ctx.row1 }, { row2: _ctx.row2 }])
      }, [
        _createElementVNode("div", _hoisted_9, [
          (!_ctx.itemN1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_AgilityRatingTooltip, { position: "right" })
                  ]),
                  _createElementVNode("img", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.itemn1(true), _ctx.toggleRow1())),
                    class: "item1-toggle plus",
                    style: {"cursor":"pointer"},
                    src: _imports_0
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_AgilityRatingPill, {
                      score: _ctx.questionnaireResults.nc_CHARACTERISTICS
                    }, null, 8, ["score"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_AgilityRatingPill, {
                      score: _ctx.questionnaireResults.nc_ORGANIZATIONAL_GOVERNANCE
                    }, null, 8, ["score"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_AgilityRatingPill, {
                      score: _ctx.questionnaireResults.nc_ORGANIZATIONAL_ARCHITECTURE
                    }, null, 8, ["score"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_AgilityRatingPill, {
                      score: _ctx.questionnaireResults.nc_TECHNICALIT_INFRASTRUCTURE
                    }, null, 8, ["score"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_AgilityRatingPill, {
                      score: _ctx.questionnaireResults.hi_HUMANIT_INFRASTRUCTURE
                    }, null, 8, ["score"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_AgilityRatingPill, {
                      score: _ctx.questionnaireResults.hi_ORGANIZATIONAL_CULTURE
                    }, null, 8, ["score"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_AgilityRatingPill, {
                      score: _ctx.questionnaireResults.hi_HUMAN_KNOWLEDGE
                    }, null, 8, ["score"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.itemN2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_AgilityRatingTooltip, { position: "right" })
                  ]),
                  _createElementVNode("img", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.itemn2(true), _ctx.toggleRow1())),
                    class: "item2-toggle",
                    style: {"cursor":"pointer"},
                    src: _imports_0
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_AgilityRatingPill, {
                        score: _ctx.questionnaireResults.env_HOSTILITY
                      }, null, 8, ["score"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_AgilityRatingPill, {
                        score: _ctx.questionnaireResults.env_DYNAMISM
                      }, null, 8, ["score"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_AgilityRatingPill, {
                        score: _ctx.questionnaireResults.env_COMPLEXITY
                      }, null, 8, ["score"])
                    ])
                  ]),
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_AgilityRatingPill, {
                        score: _ctx.questionnaireResults.env_FACTORS,
                        fill: true
                      }, null, 8, ["score"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_48, [
          (!_ctx.itemN3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode(_component_AgilityRatingTooltip, { position: "right" })
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", {
                        class: _normalizeClass([[_ctx.graphToggle3 ? 'right-1' : 'left-1'], "i3-toggle absolute bg-[#aedddb] h-5/6 top-1 rounded-xl z-0 transition ease-in-out"]),
                        style: _normalizeStyle({ width: _ctx.graphToggle3 ? 'calc(50% - 10px)' : '50%' })
                      }, null, 6),
                      _createElementVNode("p", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ici1GraphViewClick(false))),
                        class: "gv3-toggle w-1/2 text-nowrap z-10 hover:cursor-pointer"
                      }, " Graph View"),
                      _createElementVNode("p", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ici1GraphViewClick(true))),
                        class: "dv3-toggle w-1/2 text-nowrap z-10 hover:cursor-pointer"
                      }, " Data View")
                    ]),
                    _createElementVNode("img", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.itemn3(true), _ctx.toggleRow2())),
                      class: "item3-toggle",
                      style: {"cursor":"pointer"},
                      src: _imports_0
                    })
                  ])
                ]),
                (_ctx.graphToggle3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.nc_CHARACTERISTICS
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.nc_ORGANIZATIONAL_GOVERNANCE
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.nc_ORGANIZATIONAL_ARCHITECTURE
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.nc_TECHNICALIT_INFRASTRUCTURE
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.hi_HUMANIT_INFRASTRUCTURE
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.hi_ORGANIZATIONAL_CULTURE
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.hi_HUMAN_KNOWLEDGE
                            }, null, 8, ["score"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _hoisted_74,
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex-1 bg-[#fbfaff] rounded-xl p-2 items-center justify-between", { 'my-auto': _ctx.questionnaireResults.enableres, 'my-0': !_ctx.questionnaireResults.enableres }])
                        }, [
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.questionnaireResults.enableres), 1)
                          ])
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.business_AGILITY_1,
                              fill: true
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _hoisted_81
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.graphToggle3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createVNode(_component_GraphIci, {
                        small: true,
                        class: _normalizeClass('h-64 pt-4'),
                        circles: _ctx.dynamicCirclesIci1,
                        hoveredIndex: _ctx.hoveredIci1,
                        setHoveredIndex: (index) => _ctx.hoveredIci1 = index,
                        categories: _ctx.categoriesIci1
                      }, null, 8, ["circles", "hoveredIndex", "setHoveredIndex", "categories"]),
                      _hoisted_83
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.itemN4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createVNode(_component_AgilityRatingTooltip, { position: "right" })
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", {
                        class: _normalizeClass([[_ctx.graphToggle4 ? 'right-1' : 'left-1'], "i4-toggle absolute bg-[#aedddb] h-5/6 top-1 rounded-xl z-0 transition ease-in-out"]),
                        style: _normalizeStyle({ width: _ctx.graphToggle4 ? 'calc(50% - 10px)' : '50%' })
                      }, null, 6),
                      _createElementVNode("p", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ici2GraphViewClick(false))),
                        class: "gv4-toggle w-1/2 text-nowrap z-10 hover:cursor-pointer"
                      }, " Graph View"),
                      _createElementVNode("p", {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.ici2GraphViewClick(true))),
                        class: "dv4-toggle w-1/2 text-nowrap z-10 hover:cursor-pointer"
                      }, " Data View")
                    ]),
                    _createElementVNode("img", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.itemn4(true), _ctx.toggleRow2())),
                      class: "item4-toggle",
                      style: {"cursor":"pointer"},
                      src: _imports_0
                    })
                  ])
                ]),
                (_ctx.graphToggle4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.slr_SENSING
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.srl_RESPONDING
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.srl_LEARNING
                            }, null, 8, ["score"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between align-content-center", { 'my-auto': _ctx.questionnaireResults.srl_CAPABILITIES, 'my-0': _ctx.questionnaireResults.srl_CAPABILITIES }])
                        }, [
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.questionnaireResults.srl_CAPABILITIES), 1)
                          ])
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _hoisted_105,
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("div", _hoisted_107, [
                            _createVNode(_component_AgilityRatingPill, {
                              score: _ctx.questionnaireResults.business_AGILITY_2,
                              fill: true
                            }, null, 8, ["score"])
                          ])
                        ]),
                        _hoisted_108
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.graphToggle4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                      _createVNode(_component_GraphIci, {
                        small: true,
                        class: _normalizeClass('h-64 pt-4'),
                        circles: _ctx.dynamicCirclesIci2,
                        hoveredIndex: _ctx.hoveredIci2,
                        setHoveredIndex: (index) => _ctx.hoveredIci2 = index,
                        categories: _ctx.categoriesIci2
                      }, null, 8, ["circles", "hoveredIndex", "setHoveredIndex", "categories"]),
                      _hoisted_110
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.showBenchmarkDetails]
    ])
  ], 2))
}